import api from "../lib/api";
import type { SignUpData } from "../types";
export const loginApi = (payload: {
  username: string;
  password: string;
  forceLogin?: boolean;
}) => api.post("/api/auth/login", payload);
export const refreshApi = () => api.post("/api/auth/refresh");
export const logoutApi = () => api.post("/api/auth/logout");
export const meApi = ({
  latitude,
  longitude,
}: {
  latitude?: string;
  longitude?: string;
}) => api.post("/api/auth/me", { latitude, longitude });

export const signupApi = (payload: SignUpData) =>
  api.post("/api/auth/signup", payload);

export const VerifyOTPApi = (payload: {
  phone: string;
  otp: string;
  purpose: string;
}) => api.post("/api/auth/verify-otp", payload);

export const forgotApi = (payload: { email: string }) =>
  api.post("/api/auth/forgot-password", payload);

export const verifyForgotPasswordApi = (payload: {
  phone: string;
  password: string;
  confirmPassword: string;
}) => api.post("/api/auth/set-password", payload);

export const resendOtpApi = (payload: { phone: string; purpose: string }) =>
  api.post("/api/auth/resend-otp", payload);

// Profile/Security specific helpers
// export const updatePasswordApi = (payload: {
//   currentPassword: string;
//   newPassword: string;
// }) => api.post("/api/auth/update-password", payload);
export const updatePasswordApi = (payload: {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}) => api.post("/api/auth/update-password", payload);

export const editProfile = (payload: any) =>
  api.post(`/api/auth/update-profile`, payload);

export const sendEmailOtpApi = (payload: { email: string; purpose: string }) =>
  api.post("/api/auth/sendverify-email", payload);

// export const verifyEmailOtpApi = (payload: {
//   otp: string;
// }) => api.post("/api/auth/verify-email-otp", payload);
export const verifyEmailOtpApi = (payload: { otp: string; email: string }) => {
  return api.post("/api/auth/verify-email-otp", payload);
};

export const setPasswordWithEmailOtpApi = (payload: {
  email: string;
  password: string;
  confirmPassword: string;
}) => api.post("/api/auth/set-password-with-email-otp", payload);

export const getAddress = async (lat: any, lon: any) => {
  return api.get(`/api/reverse-geocode?lat=${lat}&lon=${lon}`);
};

export const sendPhoneVerification = (payload: any) =>
  api.post("/api/auth/send-verify-otp", payload);
export const checkSessionApi = () => api.get("/api/auth/check-session");

export const verifyPhoneOtpApi = (payload: {
  otp: string;
  newPhone: string;
  dialCode: string;
  phoneVerified?: boolean;
}) => api.post("/api/auth/verify-phone-otp", payload);
